exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subMenuItem[data-v-61449b2f] {\n  /* color: #ddd; */\n  /* border: 1px solid darkgreen; */\n  font-size: 16px;\n  margin-bottom: 15px;\n}\n.subMenuItem[data-v-61449b2f]:hover, .profileInformationContainer[data-v-61449b2f]:hover {\n  cursor: pointer;\n  background-color: #FFFFFF;\n  color: #000;\n  border-radius: 3px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61449b2f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/menus/MobileMenuComponents/MobileMenuSectionListItem.vue
// module id = 1565
// module chunks = 2